import React, {Component} from "react";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import CalendarInput from './../CalendarInput/CalendarInput';
import Select from "../Select/Select";
import {REQUEST_FACILITIES_DATA} from "../../actions/facilitiesActions";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {
    requestShipmentDataByAccountNumber,
    resetServiceErrorShipmentByAccountNumber
} from "../../actions/shipmentDataByAccountNumberActions";
import {resetNoResultsShipmentData} from "../../actions/shipmentDataActions";
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';

class TrackingAdvancedSearch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            shipmentDate: null,
            tenderDate: null,
            cityList: [],
            originCity: '',
            destinationCity: '',
            accountNumber: '',
            airlineCode: '526',
            airWaybillNumber: '',
            isShipmentDateValid: true,
            isTenderDateValid: true,
            isAccountNumberValid: true,
            isAirlineCodeValid: true,
            isAirWaybillValid: true,
            validationErrorCount: 0
        };
        this.handleShipmentDateChange = this.handleShipmentDateChange.bind(this);
        this.handleTenderDateChange = this.handleTenderDateChange.bind(this);
    }

    componentDidMount() {
        if (!this.props.rawFacilities) {
            this.props.getRawFacilities();
        } else if (this.state.cityList.length === 0) {
            this.loadCityList();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.rawFacilities && Object.keys(this.state.cityList).length === 0) {
            this.loadCityList();
        }
    }

    loadCityList() {
        const sortedCities = this.sortCities(this.getFacilitiesList());
        let cityOptions = [];
        cityOptions.push(this.getDefaultCity());
        sortedCities.forEach(city => {
            cityOptions.push(city);
        });
        this.setState({
            cityList: cityOptions
        });
    }

    sortCities = (cities) => {
        return cities.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        });
    };

    getFacilitiesList = () => {
        return this.props.rawFacilities.map((facility) => {
            return {
                name: `${facility.commonAirportName} - ${facility.airportCodeIATA}`,
                value: facility.airportCodeIATA
            }
        });
    };

    handleShipmentDateChange(date) {
        if (date === undefined || date === null)
            return;

        let isShipmentDateValid = true;
        if (date.length === 0)
            isShipmentDateValid = false;

        let errorCount = this.state.validationErrorCount;
        if (isShipmentDateValid !== this.state.isShipmentDateValid) {
            if (isShipmentDateValid === true)
                errorCount--;
            else
                errorCount++;
        }

        this.setState({
            shipmentDate: date,
            isShipmentDateValid: isShipmentDateValid,
            validationErrorCount: errorCount
        });
    };

    handleTenderDateChange(date) {
        if (date === undefined || date === null)
            return;

        let isTenderDateValid = true;
        if (date.length === 0)
            isTenderDateValid = false;

        let errorCount = this.state.validationErrorCount;
        if (isTenderDateValid !== this.state.isTenderDateValid) {
            if (isTenderDateValid === true)
                errorCount--;
            else
                errorCount++;
        }
        this.setState({
            tenderDate: date,
            isTenderDateValid: isTenderDateValid,
            validationErrorCount: errorCount
        });
    };

    handleDateBlur = (name, date) => {
        this.resetServerErrorsIfAny();
        if (date === undefined || date === null)
            return;

        let isDateValid = true;
        if (date.length === 0)
            isDateValid = false;
        let errorCount = this.state.validationErrorCount;

        if (name === 'shipmentDatePicker') {
            if (isDateValid !== this.state.isShipmentDateValid) {
                if (isDateValid === true)
                    errorCount--;
                else
                    errorCount++;
            }
            this.setState({
                isShipmentDateValid: isDateValid,
                validationErrorCount: errorCount
            });
        } else if (name === 'tenderDatePicker') {
            if (isDateValid !== this.state.isTenderDateValid) {
                if (isDateValid === true)
                    errorCount--;
                else
                    errorCount++;
            }
            this.setState({
                isTenderDateValid: isDateValid,
                validationErrorCount: errorCount
            });
        }
    };

    handleAirWaybillChange = (e) => {
        const regEx = /(^[0-9]+$|^$)/;

        if (!regEx.test(e.target.value)) {
            e.preventDefault();
        } else {
            this.setState({[e.target.name]: e.target.value});
        }
    };

    handleChange = (e) => {
        this.setState({[e.target.name]: e.target.value});
    };

    handleBlur = (e) => {
        this.resetServerErrorsIfAny();
        if (e.target.name === 'airlineCode' || e.target.name === 'accountNumber' || e.target.name === 'airWaybillNumber') {
            const isValid = this.validateInputs(e);
            let errorCount = this.state.validationErrorCount;
            //Validate and set validation state
            switch (e.target.name) {
                case 'airlineCode':
                    if (isValid !== this.state.isAirlineCodeValid) {
                        if (isValid === true)
                            errorCount--;
                        else
                            errorCount++;
                        this.setState({
                            isAirlineCodeValid: isValid,
                            validationErrorCount: errorCount
                        });
                    }
                    break;
                case 'accountNumber':
                    if (isValid !== this.state.isAccountNumberValid) {
                        if (isValid === true)
                            errorCount--;
                        else
                            errorCount++;
                        this.setState({
                            isAccountNumberValid: isValid,
                            validationErrorCount: errorCount
                        });
                    }
                    break;
                case 'airWaybillNumber':
                    if (isValid !== this.state.isAirWaybillValid) {
                        if (isValid === true)
                            errorCount--;
                        else
                            errorCount++;
                        this.setState({
                            isAirWaybillValid: isValid,
                            validationErrorCount: errorCount
                        });
                    }
                    break;
                default:
                    break;
            }
        }
    };

    resetServerErrorsIfAny = () => {
        if (this.props.noResults) {
            this.props.resetNoResultsShipmentData();
        }
        if (this.props.serviceError) {
            this.props.resetServiceErrorShipmentByAccountNumber();
        }
    };

    getDefaultCity = () => {
        return {
            id: "0",
            name: "ALL CITIES",
            value: "0"
        }
    };

    getDefaultSelectedCity = () => {
        if (this.state.cityList === undefined || this.state.cityList === null)
            return this.getDefaultCity();

        if (this.state.cityList.length === 0)
            return this.getDefaultCity();

        if (this.state.cityList.length > 0)
            return this.state.cityList[0];
    };

    formatDateForSubmit = (date) => {
        if (date === null)
            return;

        let formattedDate = date.format("YYYY-MM-DD");
        //Suffix the date with 05:00 as the downstream service expects that
        formattedDate += "-05:00";
        return formattedDate;
    };

    restrictNumberInput = (e) => {
        // regex to only allow numbers
        const regEx = /[0-9]+/g;
        if (!regEx.test(e.key)) {
            e.preventDefault();
        }

        //do not let user enter more than x number of characters
        if (e.target.name === 'airlineCode' && e.target.value.length > 2) {
            e.preventDefault();
        }
        if (e.target.name === 'airWaybillNumber' && e.target.value.length > 7) {
            e.preventDefault();
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.isFormValid()) {
            const searchInput = {
                prefix: this.state.airlineCode,
                airWaybillNumber: this.state.airWaybillNumber,
                accountNumber: this.state.accountNumber,
                shipmentDate: this.formatDateForSubmit(this.state.shipmentDate),
                tenderedDate: this.formatDateForSubmit(this.state.tenderDate),
                origin: (this.state.originCity === "0") ? '' : this.state.originCity,
                destination: (this.state.destinationCity === "0") ? '' : this.state.destinationCity,

            };
            this.props.requestShipmentDataByAccountNumber(searchInput);
        }
    };

    isFormValid = () => {
        let errorCount = 0;

        if (this.state.accountNumber.trim().length === 0) {
            this.setState({
                isAccountNumberValid: false
            });
            errorCount++;
        }

        if (this.state.shipmentDate === null) {
            this.setState({
                isShipmentDateValid: false
            });
            errorCount++;
        }

        if (!this.isAirlineCodeValid(this.state.airlineCode)) {
            this.setState({
                isAirlineCodeValid: false
            });
            errorCount++;
        }

        if (!this.isAirlineCodeValid(this.state.airWaybillNumber)) {
            this.setState({
                isAirWaybillValid: false
            });
            errorCount++;
        }

        if (this.state.tenderDate === null) {
            this.setState({
                isTenderDateValid: false
            });
            errorCount++;
        }

        this.setState({
            validationErrorCount: errorCount
        });

        if (errorCount > 0)
            return false;

        return true;
    };

    validateInputs = (e) => {
        if (e.target.value.trim() === '')
            return false;
        if (e.target.name === 'airlineCode' && !this.isAirlineCodeValid(e.target.value))
            return false;
        if (e.target.name === 'airWaybillNumber' && !this.isAirWaybillValid(e.target.value))
            return false;
        return true;
    };

    isAirlineCodeValid = (input) => {
        if (input.trim().length < 3)
            return false;
        return true;
    };

    isAirWaybillValid = (input) => {
        if (input.trim().length < 8)
            return false;
        return true;
    };

    getErrorMessage = () => {
        if (this.props.serviceError) {
            return 'This feature is currently not available. Please try again. If the error continues, please call our Customer CARE Center at 1 (800) 533-1222.';
        }

        if (this.props.noResults) {
            return 'Air waybill(s) are not found with the selected criteria. Please check the account number, shipment date, air waybill date, and/or tender date, and try again.';
        }

        if (this.state.validationErrorCount <= 0)
            return '';

        if (this.state.validationErrorCount > 1)
            return 'There are multiple errors with your submission. Please review and try again.';

        if (this.state.validationErrorCount === 1) {
            if (this.state.isAccountNumberValid === false) {
                return 'Please enter a valid master account number.'
            }
            if (this.state.isShipmentDateValid === false) {
                return 'Please pick a valid shipment date.'
            }
            if (this.state.isAirlineCodeValid === false) {
                return 'Please enter a valid airline code.'
            }
            if (this.state.isAirWaybillValid === false) {
                return 'Please enter a valid air waybill number.'
            }
            if (this.state.isTenderDateValid === false) {
                return 'Please pick a valid tender date.'
            }
        }
    };


    render() {
        return (
                <div className="tracking-advanced-search-wrapper">
                    <div
                            className={this.state.validationErrorCount > 0 || this.props.noResults || this.props.serviceError ? 'tracking-advanced-search-error-wrapper alert alert-danger'
                                    : 'tracking-advanced-search-error-wrapper tracking-advanced-search-error-wrapper-hide'}>
                        {this.getErrorMessage()}
                    </div>
                    <div className="tracking-advanced-search-description">
                        To track all shipments for a specific day, please enter a Cargo account number and the desired date. Please
                        note tracking by account number is only available ten days from the shipment arrival date.
                    </div>

                    <div className="tracking-advanced-search-required">
                        <span className="tracking-advanced-search-superscript-required-header">*</span>
                        <span> Required </span>
                    </div>

                    <form name="advanced-search" onSubmit={this.handleSubmit} noValidate>
                        <div className="tracking-advanced-search-row">
                            <div className="tracking-advanced-search-column__left tracking-advanced-search-column__account-number">
                                <div className="tracking-advanced-search-column-label">
                                    Master Account number<span className="tracking-advanced-search-superscript">*</span>
                                </div>
                                <div className="tracking-advanced-search-input-wrapper">
                                    <input type="text"
                                           className={this.state.isAccountNumberValid === true ? 'tracking-advanced-search-input' : 'tracking-advanced-search-input tracking-advanced-search-input-error'}
                                           name="accountNumber"
                                           onChange={this.handleChange} value={this.state.accountNumber}
                                           onKeyPress={this.restrictNumberInput.bind(this)}
                                           onBlur={this.handleBlur}/>
                                    <img src="./assets/icons/error.svg"
                                         className={this.state.isAccountNumberValid === true ? 'tracking-advanced-search-error-icon-hide' : 'tracking-advanced-search-error-icon'}
                                         alt="Error"/>
                                </div>
                            </div>

                            <div className="tracking-advanced-search-column__shipment-date">
                                <div className="tracking-advanced-search-column-label">
                                    Shipment Date<span className="tracking-advanced-search-superscript">*</span>
                                </div>
                                <div className="tracking-advanced-search-calendar">
                                    <DatePicker
                                            name="shipmentDatePicker"
                                            className="tracking-advanced-search-calendar"
                                            customInput={<CalendarInput
                                                    handleCalendarBlur={this.handleDateBlur}
                                                    isValid={this.state.isShipmentDateValid}
                                            />}
                                            selected={this.state.shipmentDate}
                                            onChange={this.handleShipmentDateChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="tracking-advanced-search-row tracking-advanced-search-row-last">
                            <div className="tracking-advanced-search-column__origin-city">
                                <Select
                                        selected={this.getDefaultSelectedCity()}
                                        name="originCity"
                                        title="Origin"
                                        required={false}
                                        options={
                                            this.state.cityList.map((city) => {
                                                        return {
                                                            name: city.name,
                                                            value: city.value
                                                        }
                                                    }
                                            )
                                        }
                                        onChange={this.handleChange}
                                        desktopWidth={'100%'}
                                        tabletWidth={'100%'}
                                        mobileWidth={'100%'}
                                />
                            </div>
                            <div className="tracking-advanced-search-column__destination-city">
                                <Select
                                        selected={this.getDefaultSelectedCity()}
                                        name="destinationCity"
                                        title="Destination"
                                        required={false}
                                        options={
                                            this.state.cityList.map((city) => {
                                                        return {
                                                            name: city.name,
                                                            value: city.value
                                                        }
                                                    }
                                            )
                                        }
                                        onChange={this.handleChange}
                                        desktopWidth={'100%'}
                                        tabletWidth={'100%'}
                                        mobileWidth={'100%'}
                                />
                            </div>
                        </div>

                        <div className="tracking-advanced-search-account-verification-label">
                            Account Verification
                        </div>
                        <div className="tracking-advanced-search-account-verification-description">
                            To protect the privacy of your shipping information, please enter one valid air waybill number and provide
                            the respective date the shipment was tendered. The air waybill must have been shipped in the last ten days,
                            paid by the applicable Southwest Cargo Account, and weigh 16 ounces or more.
                        </div>

                        <div className="tracking-advanced-search-air-waybill-row">
                            <div className="tracking-advanced-search-column__left tracking-advanced-search-column__airline-code">
                                <div className="tracking-advanced-search-column-label">
                                    Airline Code<span className="tracking-advanced-search-superscript">*</span>
                                </div>
                                <div className="tracking-advanced-search-input-wrapper">
                                    <input type="text"
                                           className={this.state.isAirlineCodeValid === true ? 'tracking-advanced-search-input tracking-advanced-search-input__airline-code'
                                                   : 'tracking-advanced-search-input tracking-advanced-search-input__airline-code tracking-advanced-search-input-error'}
                                           name="airlineCode"
                                           onKeyPress={this.restrictNumberInput.bind(this)}
                                           onBlur={this.handleBlur}
                                           onChange={this.handleChange} value={this.state.airlineCode}/>
                                    <img src="./assets/icons/error.svg"
                                         className={this.state.isAirlineCodeValid === true ? 'tracking-advanced-search-error-icon-hide' : 'tracking-advanced-search-error-icon'}
                                         alt="Error"/>
                                </div>
                            </div>
                            <div className="tracking-advanced-search-column__left tracking-advanced-search-column__air-waybill">
                                <div className="tracking-advanced-search-column-label">
                                    8-digit Air Waybill<span className="tracking-advanced-search-superscript">*</span>
                                </div>
                                <div className="tracking-advanced-search-input-wrapper">
                                    {/*pattern invokes number keypad on mobile devices and restricts input to numbers only*/}
                                    <input type="text" pattern="[0-9]*" inputMode="numeric" name="airWaybillNumber"
                                           className={this.state.isAirWaybillValid === true ? 'tracking-advanced-search-input'
                                                   : 'tracking-advanced-search-input tracking-advanced-search-input-error'}
                                           onBlur={this.handleBlur}
                                           onChange={this.handleAirWaybillChange} value={this.state.airWaybillNumber}
                                           maxLength="8"/>
                                    <img src="./assets/icons/error.svg"
                                         className={this.state.isAirWaybillValid === true ? 'tracking-advanced-search-error-icon-hide' : 'tracking-advanced-search-error-icon'}
                                         alt="Error"/>
                                </div>
                            </div>

                            <div className="tracking-advanced-search-column__tender-date">
                                <div className="tracking-advanced-search-column-label">
                                    Air Waybill Tender Date<span className="tracking-advanced-search-superscript">*</span>
                                </div>
                                <div>
                                    <DatePicker
                                            name='tenderDatePicker'
                                            className="tracking-advanced-search-calendar"
                                            customInput={<CalendarInput
                                                    handleCalendarBlur={this.handleDateBlur}
                                                    isValid={this.state.isTenderDateValid}
                                            />}
                                            selected={this.state.tenderDate}
                                            onChange={this.handleTenderDateChange}
                                            minDate={moment().subtract(10, "days")}
                                            maxDate={moment()}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="tracking-advanced-search-submit">
                            <button type="submit" className="button cta-button" disabled={this.props.isFetching}>
                                <span className="tracking-advanced-search-submit__button"> Track </span>
                            </button>
                        </div>
                        <Modal open={this.props.isFetching}
                               disableBackdropClick={true}
                               disableAutoFocus={true}>
                            <CircularProgress className={'tracking-advanced-circular-progress'}/>
                        </Modal>
                    </form>

                </div>
        )
    }
}

const mapStateToProps = state => ({
    rawFacilities: state.facilitiesData.rawFacilities,
    noResults: state.shipmentData.noResults,
    serviceError: state.shipmentDataByAccountNumber.serviceError || state.facilitiesData.error,
    isFetching: state.shipmentData.isFetching
});

const mapDispatchToProps = dispatch => ({
    getRawFacilities: () => dispatch({type: REQUEST_FACILITIES_DATA}),
    requestShipmentDataByAccountNumber: data => {
        dispatch(requestShipmentDataByAccountNumber(data))
    },
    resetNoResultsShipmentData: () => {
        dispatch(resetNoResultsShipmentData())
    },
    resetServiceErrorShipmentByAccountNumber: () => {
        dispatch(resetServiceErrorShipmentByAccountNumber())
    }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TrackingAdvancedSearch));



// WEBPACK FOOTER //
// ./src/components/TrackingAdvancedSearch/TrackingAdvancedSearch.js